import { type Readable, readable } from "svelte/store";
import { otto } from "../../../exports/nexus.js";
import { getToggle } from "../../toggle/get.js";

const { assignments } = otto.onex;

/**
 *
 *
 */
export interface OnexVariantValue<D extends App.Onex, O extends keyof D, V = boolean> {
  /**
 *
 */
  onexId: O;
  /**
 *
 */
  variant: D[O] | undefined;
  /**
 *
 */
  value: V;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const onexVariant = <D extends App.Onex, O extends keyof D, V extends NonNullable<D[O]>>(
  onexId: O,
  variantId: V,
): Readable<OnexVariantValue<D, O>> => {
  const current = assignments.get()?.[onexId as string] as D[O] | undefined;

  const res = readable<OnexVariantValue<D, O>>(
    { onexId, variant: current, value: current === variantId },
    (set) =>
      assignments.sub((a) => {
        const variant = a[onexId as string] as D[O] | undefined;
        set({ onexId, variant, value: variant === variantId });
      }),
  );

  return res;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const onexValue = <
  D extends App.Onex,
  O extends keyof D,
  M extends Record<D[O] & string, unknown>,
  F = undefined,
>(
  onexId: O,
  variantMap: M,
  ...a: undefined extends F ? [] : [defaultValue: F]
): Readable<OnexVariantValue<D, O, M[keyof M] | F>> => {
  const current = assignments.get()?.[onexId as string] as (D[O] & string) | undefined;

  const computeValue = (variant: (D[O] & string) | undefined): M[keyof M] | F =>
    variant && variantMap[variant] !== undefined ? variantMap[variant] : (a[0] as F);

  const res = readable<OnexVariantValue<D, O, M[keyof M] | F>>(
    { onexId, variant: current, value: computeValue(current) },
    (set) =>
      assignments.sub((onex) => {
        const variant = onex[onexId as string] as (D[O] & string) | undefined;
        set({ onexId, variant, value: computeValue(variant) });
      }),
  );

  return res;
};

export type OnexByToggleOptions = {
  /**
 *
 */
  enabled?: boolean;
  /**
 *
 */
  onexId?: string;
  /**
 *
 */
  variants?: string[];
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const onexVariantByToggle = <
  T extends string,
  VKey extends NonNullable<Options["variants"]>[number],
  const Options extends OnexByToggleOptions = {
    enabled: true;
    onexId: T;
    variants: ["variantA", "variantB", "variantC", "variantD"];
  },
>(
  toggleId: T,
  variantKey: VKey,
  options: Options = {} as Options,
): Readable<OnexVariantValue<App.Onex, string>> => {
  /*                             */
  const {
    enabled: defaultEnabled = true,
    onexId = "unknown",
    variants = ["variantA", "variantB", "variantC", "variantD"],
  } = options;

  /*                                                                           */
  const variantIndex = variants.indexOf(variantKey);
  if (typeof variantIndex !== "number" || variantIndex === -1)
    throw new Error(`Variant Key ${variantKey} is not defined in the mapping`);

  const computeValue = (
    id: string,
    current: string | undefined,
    value = current === variants[variantIndex],
  ): OnexVariantValue<App.Onex, string> => ({ onexId: id, variant: current, value });

  const res = readable<OnexVariantValue<App.Onex, string>>(computeValue(onexId, undefined), (set) =>
    assignments.subscribe((onex) => {
      /*                                                               */
      /*                                   */
      if (onex[toggleId]) {
        return set(computeValue(toggleId, onex[toggleId]));
      }

      /*                               */
      const [isEnabled, payload] = getToggle(toggleId, defaultEnabled, { onexId, variants });

      const realOnexId = payload.onexId;
      const realVariantId = payload.variants[variantIndex] ?? variants[variantIndex];
      const currentVariant = onex[realOnexId];

      set(computeValue(realOnexId, currentVariant, isEnabled && currentVariant === realVariantId));
    }),
  );

  return res;
};
